import React from 'react';

export default function Logo() {
  return (
    <svg className="logo-animation w-10 h-10" viewBox="0 0 48 48" fill="none">
      <path 
        d="M24 4L6 14V34L24 44L42 34V14L24 4Z" 
        stroke="url(#logo-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M24 44V24M24 24L6 14M24 24L42 14" 
        stroke="url(#logo-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <circle cx="24" cy="24" r="6" fill="url(#logo-gradient)" opacity="0.8"/>
      <defs>
        <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:'#38bdf8', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#a855f7', stopOpacity:1}} />
        </linearGradient>
      </defs>
    </svg>
  );
}